import { StaffCalendarLegend } from "../../shared/StaffCalendarLegend";

export function AttendanceLegend() {
  return <StaffCalendarLegend mode="attendance" />;
}
